import axios from '../index'

export function archive(params) {
  return axios.post(`/ajax/users/ai_content/content_entities/${params.id}/archive`, { params })
}

export function generateContentEntity(params) {
  return axios.post('/ajax/users/ai_content/content_entities/custom_generate', params)
}

export function rerun(params) {
  return axios.post(`/ajax/users/ai_content/content_entities/${params.id}/rerun`, params)
}

export function massDestroy(ids) {
  return axios.delete('/ajax/users/ai_content/content_entities/mass_destroy', {
    params: { content_entities_ids: ids }
  })
}
